/*
 *  I15HYDROACCUCalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-06-18 13:39:25 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15HYDROACCU_State } from '@batical/types/src'

function I15HYDROACCU_docalcul(state: I15HYDROACCU_State) {
  //TODO CALCUL
  if (state.in_puissance === 0) {
    state.res_volume_tampon_nominal = 0
    if (state.in_puissance_chaudiere < state.in_puissance_mini_chaudiere) {
      state.res_volume_tampon = 0
      return state
    }

    state.res_volume_tampon = Math.max(
      0,
      0.015 *
        state.in_duree_charge_bois *
        state.in_puissance_chaudiere *
        (1 - (0.3 * state.in_deperdition) / state.in_puissance_mini_chaudiere) *
        1000
    )
  } else if (state.in_puissance === 1) {
    state.res_volume_tampon = 0
    if (state.in_temp_max_stockage < state.in_temp_retour) {
      state.res_volume_tampon_nominal = 0
      return state
    }
    state.res_volume_tampon_nominal =
      state.in_e_liberee / 1.163 / (state.in_temp_max_stockage - state.in_temp_retour) - state.in_capacite_eau_chaudiere
  }
  return state
}

export default I15HYDROACCU_docalcul
